import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ThePageTitle from '@/components/v2/PageTitle.vue';
import InquiryRequest from '@/components/v2/inquiry/InquiryRequest';
import Avatar from '@/components/avatar/Index.vue';
import { DATA_TABLES_ITEMS } from '@/helpers/constants/app';
/**
 * Component for rendering general inquiry requests
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.18}
 */
let GeneralInquiries = class GeneralInquiries extends mixins(RouterParamsAppMixin) {
    get dataTableItems() {
        return DATA_TABLES_ITEMS;
    }
    get headers() {
        return [
            {
                text: 'CUSTOMER',
                value: 'customer',
                align: 'left',
                sortable: false,
            },
            {
                text: 'INQUIRY MESSAGE',
                value: 'message',
                align: 'left',
                sortable: false,
            },
        ];
    }
};
GeneralInquiries = __decorate([
    Component({
        components: {
            Avatar,
            InquiryRequest,
            ThePageTitle,
        },
    })
], GeneralInquiries);
export default GeneralInquiries;
